/**
 * LoadingSpinner Component - AWLP Design System
 * Animated spinner for loading states
 */

import styled, { keyframes } from 'styled-components';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface LoadingSpinnerProps {
  size?: SpinnerSize;
  color?: string;
  className?: string;
}

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const getSizeValue = (size: SpinnerSize): string => {
  const sizes = {
    sm: '16px',
    md: '24px',
    lg: '40px',
  };
  return sizes[size];
};

const getBorderWidth = (size: SpinnerSize): string => {
  const widths = {
    sm: '2px',
    md: '3px',
    lg: '4px',
  };
  return widths[size];
};

const Spinner = styled.div<{ $size: SpinnerSize; $color?: string }>`
  display: inline-block;
  width: ${({ $size }) => getSizeValue($size)};
  height: ${({ $size }) => getSizeValue($size)};
  border: ${({ $size }) => getBorderWidth($size)} solid
    ${({ theme, $color }) => $color || theme.colors.primary.base}33;
  border-top-color: ${({ theme, $color }) => $color || theme.colors.primary.base};
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingSpinner = ({ size = 'md', color, className }: LoadingSpinnerProps) => {
  return (
    <Container className={className}>
      <Spinner $size={size} $color={color} />
    </Container>
  );
};

export default LoadingSpinner;
